import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  getMilestonesClientsBySubCourse,
  getSubCoursesClientByCourseId,
} from "../../store/actions/CreateCourse/CourseApi";
import PlayerPageMileStoneCard from "./PlayerPageMileStoneCard";

const PlayerPageCardMilestone = ({
  subCourse,
  courseId,
  playerCard1Object,
  setCurrentItem,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { subCourseId, item, itemId,itemToken } = useParams();

  const currentToken = useSelector((s) => s?.user?.user?.currentToken);
  const userEmail = useSelector((s) => s?.user?.user?.userData?.userEmail);

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSubCourse, setCurrentSubCourse] = useState(null);

  const didInitRedirect = useRef(false);
 const fireGetMilestonesClientsBySubCourse=(subCourseItemId)=>{
    setItems([]);

    dispatch(
      getMilestonesClientsBySubCourse({
        userEmail: userEmail || "",
        currentToken: currentToken || "",
        productType: "course",
        courseId,
        postParent: subCourseItemId, // ✅ CORRECT
      })
    )
      .then((res) => {
        setItems(res?.mileStones || []);
      })
      .finally(() => setLoading(false));
      }
  /* --------------------------------------------------
     1️⃣ INITIAL SUBCOURSE REDIRECT (TOKEN → URL)
  -------------------------------------------------- */
  useEffect(() => {
  
  setTimeout(()=>{
 
     dispatch(
      getSubCoursesClientByCourseId({
        userEmail: userEmail || "",
        currentToken: currentToken || "",
        productType: "course",
        courseId,
      })
    ).then((res) => {
         const first = res?.subCourses?.[0];
      if (!first?.SubCourseAppToken) return;
 
         const subCourses = res?.subCourses || [];
      if (!subCourses.length) return;

     
      // 🔹 Case 1: Reload / Deep link (token exists in URL)
      if (subCourseId) {
        const matched = subCourses.find(
          (sc) => sc.SubCourseAppToken === subCourseId
        );

        if (matched) {
          fireGetMilestonesClientsBySubCourse(matched?.ID)
          return;
        }
       
      }   history.replace(
        `/player/course/${courseId}/subcourse/${first.SubCourseAppToken}`
      );
     
    });
  },10)
   
  }, [subCourseId]);

  /* --------------------------------------------------
     2️⃣ FETCH MILESTONES (ID → API, TOKEN → ROUTE)
  -------------------------------------------------- */
  useEffect(() => {
    if (!subCourse?.ID || !subCourse?.SubCourseAppToken) return;

    const targetPath = `/player/course/${courseId}/subcourse/${subCourse.SubCourseAppToken}/${item ? item + "/" : ""}${itemId?itemId+ "/" : ""}${itemToken?itemToken :""}`;

    if (history.location.pathname !== targetPath) {
      history.push(targetPath); // ✅ back button safe
    }

    setLoading(true);
   
      fireGetMilestonesClientsBySubCourse(subCourse?.ID)
  }, [ subCourse?.ID, subCourse?.SubCourseAppToken,]);

  /* --------------------------------------------------
     3️⃣ RENDER
  -------------------------------------------------- */
  if (loading) return <>loading</>;

  if (!items.length) return <>No milestones found</>;

  return (
    <>
      {items.map((milestone, index) => (
        <PlayerPageMileStoneCard
          key={milestone?.ID || index}
          courseId={courseId}
          playerCard1Object={playerCard1Object}
          setCurrentItem={setCurrentItem}
          contentItem={milestone}
          milestoneNo={index + 1}
        />
      ))}
    </>
  );
};

export default PlayerPageCardMilestone;
